module.exports = __webpack_public_path__ + "static/media/WaitPayment.1bcfe831.svg";